import { FC, Fragment, useReducer } from 'react';

import { Plus } from 'lucide-react';
import { toast } from 'sonner';
import useSWRMutation from 'swr/mutation';

import Button from '@mui/material/Button';

import { initialValues, StoreProductForm } from '../storeProducts/form';
import { StoreProductFormDialog } from '../storeProducts/storeProductFormDialog/StoreProductFormDialog';

import { storeService } from 'v2/api/storeService';
import { handleHttpError } from 'v2/utils';

interface AddStoreProductButtonProps {
  onSuccess: VoidFunction;
}

export const AddStoreProductButton: FC<AddStoreProductButtonProps> = ({ onSuccess }) => {
  const [isOpen, setOpen] = useReducer((state) => !state, false);

  const { trigger, isMutating } = useSWRMutation('createStoreProduct', storeService.createStoreProduct, {
    onSuccess: () => {
      onSuccess();
      toast.success('The product has been successfully created');
      setOpen();
    },
    onError: handleHttpError,
  });

  const handleSubmit = (values: StoreProductForm, resetForm: VoidFunction) => {
    trigger(values).then(() => resetForm());
  };

  return (
    <Fragment>
      <Button onClick={setOpen} startIcon={<Plus />} variant="contained" size="large">
        Create Product
      </Button>

      <StoreProductFormDialog
        title="Create Store Product"
        isOpen={isOpen}
        onClose={setOpen}
        initialValues={initialValues}
        isSubmitting={isMutating}
        onSubmit={handleSubmit}
      />
    </Fragment>
  );
};
